import { Toast } from "antd-mobile"
import { stringify } from "querystring"
import { initConfig } from "../servers"
const hasWindow = () => typeof window === "object"
const inWxwork = () => /wxwork/gi.test(window.navigator.userAgent)
const _window = window as any
const wx = _window.wx

const canIUse = () => hasWindow() && inWxwork() && wx
const init = (options?: any) => {
  // 校验执行环境
  if (!canIUse()) {
    Toast.info("应用不支持当前环境访问!", 3)
    if (options && typeof options.onError === "function") {
      options.onError()
    }
    return
  }
  initConfig({ url: _window.location.href })
    .then((res) => {
      if (!res) {
        return
      }
      const { data } = res
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.corpid, // 必填，企业微信的corpID
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: [
          "startRecord",
          "stopRecord",
          "onVoiceRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "onVoicePlayEnd",
          "uploadVoice",
          "downloadVoice",
          "onMenuShareWechat",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareAppMessage",
          "onMenuShareWechat",
          "onMenuShareTimeline",
        ], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
        ...options,
        complete: (data: any) => {
          console.log("wx config complete ===", data)
        },
      })
      wx.ready(() => {
        initAgentConfig(options)
      })
      wx.error((e: any) => {
        console.log("qywx.ts => config fail:", e)
      })
    })
    .catch((e) => {
      console.warn("qywx init catch =>", e)
    })
}

const wxInvoke = (method: any, params?: any, options?: any) => {
  console.log("wxInvoke", params)
  if (!canIUse || !wx.invoke) {
    if (options && options.errorCallback) {
      options.errorCallback()
    }
    return
  }
  try {
    wx.invoke(method, params, (res: any) => {
      console.log(`invoke method:${method}, res: ${stringify(res)}`)
      if (res.err_msg?.includes("ok")) {
        if (options && options.cb) {
          options.cb(res.userId || res.chatId)
        }
        if (options && options.successCallback) {
          options.successCallback(res)
        }
      } else {
        const { errorTip = true } = options
        //错误处理  失败的提示出来 err_code=1
        if (res.err_msg?.includes("fail") && errorTip) {
          Toast.fail(`【${method}】调用失败:${res?.err_msg}`)
        } else if (res.err_msg === "function_not_exist") {
          Toast.fail("当前客户端版本不支持该接口，请升级到新版体验。")
        }
        console.warn(`invoke ===> catch error:${stringify(res)}`)
        if (options && options.errorCallback) {
          options.errorCallback()
        }
      }
    })
  } catch (e: any) {
    console.log(e)
    if (options && options.errorCallback) {
      options.errorCallback()
    }
  }
}

const getWxMethod = (method: any, params?: any) => {
  console.log(`getWxMethod method:[${method}], params:[${params}]`)
  if (canIUse() && wx && wx[method]) {
    wx[method](params)
  }
}

const initAgentConfig = (options?: any) => {
  const API_LIST = [
    "getCurExternalContact",
    "sendChatMessage",
    "openUserProfile",
    "getContext",
    "shareAppMessage",
    "openDefaultBrowser",
    "getCurExternalChat",
    "launchMiniprogram",
    "onMenuShareAppMessage",
    "onMenuShareWechat",
    "onMenuShareTimeline",
  ]
  initConfig({
    url: _window.location.href,
    queryType: 2,
  })
    .then((res) => {
      const { corpid, agentid, timestamp, nonceStr, signature } = res.data

      wx.checkJsApi({
        jsApiList: API_LIST, // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: (r: any) => {
          console.log("jsApiList:", r)
        },
      })
      wx.agentConfig({
        corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentid, // 必填，企业微信的应用id （e.g. 1000247）
        timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
        jsApiList: API_LIST, //必填
        success: () => {
          console.log("SDK初始化完成")
          if (options && typeof options.ready === "function") {
            options.ready()
          }
        },
        fail: (e: any) => {
          Toast.fail(`SDK初始化异常 ${stringify(e)}`)
          console.warn("SDK初始化异常 agentConfig fail => ", e)
        },
      })
    })
    .catch((e) => {
      console.warn("initAgentConfig catch=>:", e)
    })
}

export { init, getWxMethod, initAgentConfig, wxInvoke, wx, inWxwork }
